import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import BaseUnitType from "../../Utility/Crud/BaseUnitType";

export default class ChipBaseUnitType extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color = this.props.baseUnitType ? BaseUnitType.getColor() : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {BaseUnitType.getIcon({ fontSize: "small", sx: { color: iconColor } })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The baseUnitType name.
   */
  getLabel() {
    return this.props.baseUnitType
      ? BaseUnitType.getDisplayName(this.props.baseUnitType)
      : "None";
  }
}
